import React from 'react'
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { get } from '../../services/ApiService';

function Sidebar() {
    const pathName = window.location.pathname;
    const [rolePermissions, setRolePermissions] = useState([]);


    const getList = async (page = 1) => {
        let data = { page: 1, recPerPage: 500, q: "", func: '' }
        let res = await get('/urm/role/get-permissions', data);
        if (res.status === 1) {
            // let data = res;//.json();
            setRolePermissions(res.payload);
        }
    }

    useEffect(() => {
        getList()
    }, [])
    return (
        <div id="layout-wrapper">

            <div className="app-menu navbar-menu">


                <ul className="navbar-nav">
                    <li className="nav-item outer-nav mt-4">
                        <NavLink to={'/dashboard'} className="nav-link menu-link" >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#525b75" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                            </svg>
                            <span data-key="t-dashboards sideFirstTabFont mx-2">Dashboard</span>
                        </NavLink>
                    </li>
                    {


                        // (rolePermissions.find((element) => element.slug == 'panelist')) ? (
                            <>
                                <li className="nav-item outer-nav">
                                    <a className="nav-link menu-link" href="#Panelist" data-bs-toggle="collapse" role="button" aria-expanded={(pathName === '/clients/active' || pathName === '/clients/incomplete' || pathName === '/clients/multiplier-request' || pathName === '/clients/deleted') ? 'true' : 'false'} aria-controls="Panelist">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#525b75" class="size-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                                        </svg>
                                        <span data-key="t-authentication">Clients</span>
                                    </a>
                                    <div className={(pathName === '/clients/active' || pathName === '/clients/incomplete' || pathName === '/clients/multiplier-request' || pathName === '/clients/deleted') ? 'collapse menu-dropdown show' : 'collapse menu-dropdown'} id="Panelist">
                                        <ul className="nav nav-sm flex-column">
                                        <li className="nav-item">
                                                <NavLink to={'/clients/active'} className="nav-link"> Client List </NavLink>
                                            </li>
                                            <li className="nav-item">
                                                {/* <NavLink to={'/clients/incomplete'} className="nav-link"> Brand Score Request </NavLink> */}
                                            </li>
                                            <li className="nav-item">
                                                <NavLink to={'/clients/multiplier-request'} className="nav-link">Multiplier Request</NavLink>
                                            </li>
                                             <li className="nav-item">
                                                <NavLink to={'/clients/funnel-request'} className="nav-link">Funnel Request</NavLink>
                                            </li>
                                           
                                        </ul>
                                    </div>
                                </li>
                            </>
                        // ) : (<></>)


                    }

                    {/* {(rolePermissions.find((element) => element.slug == 'research'))?(  */}
                    <li className="nav-item">
                        <a className="nav-link menu-link" href="#Datamanager" data-bs-toggle="collapse" role="button" aria-expanded={(pathName.includes('research')) ? 'true' : 'false'} aria-controls="Datamanager">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="#525b75" class="size-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
                            </svg>
                            <span data-key="t-authentication">Data</span>
                        </a>
                        <div className={(pathName.includes('research')) ? 'collapse menu-dropdown show' : 'collapse menu-dropdown'} id="Datamanager">
                            <ul className="nav nav-sm flex-column">
                                {/* {(rolePermissions.find((element) => element.slug == 'research-upload-respondent'))&&( */}
                               
                                <li className="nav-item">
                                    <NavLink to={'/research/variables'} className="nav-link">Population data</NavLink>
                                </li>
                                 <li className="nav-item">
                                    <NavLink to={'/research/brand-kpi'} className="nav-link">Brand KPI data</NavLink>
                                </li>
                                {/* )}  */}
                                {/* {(rolePermissions.find((element) => element.slug == 'research-study'))&&( */}

                                {/* <li className="nav-item">
                                    <NavLink to={'/research/study'} className="nav-link"> Study </NavLink>
                                </li> */}
                                {/* )}  */}

                                {/* {(rolePermissions.find((element) => element.slug == 'research-primary'))&&( */}

                                {/* <li className="nav-item">
                                    <NavLink to={'/research/primary'} className="nav-link"> Primary </NavLink>
                                </li> */}
                                {/* )}  */}

                                {/* <li className ="nav-item">
                                            <NavLink to={'#'} className ="nav-link"> Secondary </NavLink>
                                        </li> */}
                                {/* {(rolePermissions.find((element) => element.slug == 'research-report'))&&( */}

                                {/* <li className="nav-item">
                                    <NavLink to={'/research/report'} className="nav-link"> Report </NavLink>
                                </li> */}
                                {/* )}  */}
                                {/* <li className="nav-item">
                                    <NavLink to={'/research/screener'} className="nav-link"> Screener </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/research/update'} className="nav-link"> Update </NavLink>
                                </li> */}

                                {/* <li className ="nav-item">
                                            <NavLink to={'/primary-researcher-access'} className ="nav-link"> Primary Researcher </NavLink>
                                        </li> */}

                            </ul>
                        </div>
                    </li>
                    {/* ):(<></>)}  */}
                 

    <li className ="nav-item">
    <a className ="nav-link menu-link" href="#Questionnaire" data-bs-toggle="collapse" role="button" aria-expanded={(pathName==='/category' || pathName==='/product' || pathName === '/question' || pathName === '/question-set') ? 'true' : 'false'} aria-controls="Questionnaire">
        <i className ="ri-user-fill"></i> <span data-key="t-authentication">Settings</span>
    </a>
    <div className={(pathName==='/internet-activity' || pathName==='/brand' || pathName === '/kpi' || pathName === '/question-set') ? 'collapse menu-dropdown show' : 'collapse menu-dropdown'} id="Questionnaire">
        <ul className ="nav nav-sm flex-column">  
       {/* { (rolePermissions.find((element) => element.slug == 'categories'))?( */}
        <li className="nav-item">
            <NavLink to={'/internet-activity'} className="nav-link menu-link"  >
                <i className="ri-global-line"></i> <span data-key="t-apps">Internet Activity</span>
            </NavLink>
        </li>
                            
    {/*}):(<></>)} */}
    
    {/* {
        (rolePermissions.find((element) => element.slug == 'products'))?(   */}
        <li className="nav-item">
            <NavLink to={'/brand'} className="nav-link menu-link" >
                <i className="ri-price-tag-3-line"></i> <span data-key="t-apps">Brands</span>
            </NavLink>
        </li>
        
        {/* ):(<></>)                                    
    } */}

{/* {
        (rolePermissions.find((element) => element.slug == 'Index Names'))?(   */}
            <li className="nav-item">
                <NavLink to={'/kpi'} className="nav-link menu-link" >
                    <i className="ri-bar-chart-2-line"></i> <span data-key="t-apps">Key Indicators</span>
                </NavLink>
            </li>
            {/* ):(<></>)} */}

{/* {
(rolePermissions.find((element) => element.slug == 'question-mapping'))?( 
                        
                            <li className="nav-item">
                                <NavLink to={'/question-set'} className="nav-link menu-link" >
                                    <i className="ri-question-answer-fill"></i> <span data-key="t-apps">Question Mapping</span>
                                </NavLink>
                            </li>
                            ):(<></>)

                                                        
                        } */}
                        
                        </ul>
    </div>
    </li>

                            {/*
                        {
(rolePermissions.find((element) => element.slug == 'survey'))?( 

                            <li className="nav-item">
                                <NavLink to={'/survey-list'} className="nav-link menu-link" >
                                    <i className="ri-pencil-ruler-2-line"></i> <span data-key="t-apps">Surveys</span>
                                </NavLink>
                            </li>
                            ):(<></>)

                                                        
                        }

{
(rolePermissions.find((element) => element.slug == 'poll'))?( 
                        
                            <li className="nav-item">
                                <NavLink to={'/poll'} className="nav-link menu-link" >
                                    <i className="ri-apps-2-line"></i> <span data-key="t-apps">Poll</span>
                                </NavLink>
                            </li>
                            ):(<></>)

                                                        
}

{
(rolePermissions.find((element) => element.slug == 'redeem'))?( 

                            <li className="nav-item">
                                <NavLink to={'/redeem'} className="nav-link menu-link" >
                                    <i className="ri-picture-in-picture-2-line"></i> <span data-key="t-apps">Currency Value</span>
                                </NavLink>
                            </li>
                            ):(<></>)

                                                        
                        }
                        
{
(rolePermissions.find((element) => element.slug == 'coupon'))?( 

                            <li className="nav-item">
                                <NavLink to={'/coupon'} className="nav-link menu-link" >
                                    <i className="ri-exchange-cny-line"></i> <span data-key="t-apps">Coupon</span>
                                </NavLink>
                            </li>
                             ):(<></>)

                                                        
                            }

{
(rolePermissions.find((element) => element.slug == 'donation'))?( 
                            <li className="nav-item">
                                <NavLink to={'/donation'} className="nav-link menu-link" >
                                    <i className="ri-account-circle-line"></i> <span data-key="t-apps">Donation</span>
                                </NavLink>
                            </li>

):(<></>)

                                                        
}

{
(rolePermissions.find((element) => element.slug == 'transaction'))?( 
                            <li className="nav-item">
                                <NavLink to={'/transaction'} className="nav-link menu-link" >
                                    <i className="ri-layout-3-line"></i> <span data-key="t-apps">Transaction</span>
                                </NavLink>
                            </li>
                            ):(<></>)

                                                        
                        }
                            <hr />
                            

                            {
                            (rolePermissions.find((element) => element.slug == 'user-management'))?( 
                            <li className ="nav-item">
                                <a className ="nav-link menu-link" href="#sidebarAuth2" data-bs-toggle="collapse" role="button" aria-expanded={(pathName==='/urm/roles' || pathName==='/urm/modules' || pathName==='/urm/users') ? 'true' : 'false'} aria-controls="sidebarAuth2">
                                    <i className ="ri-user-fill"></i> <span data-key="t-authentication">Access Manager</span>
                                </a>
                                <div className={(pathName==='/urm/roles' || pathName==='/urm/modules' || pathName==='/urm/users') ? 'collapse menu-dropdown show' : 'collapse menu-dropdown'} id="sidebarAuth2">
                                    <ul className ="nav nav-sm flex-column">
                                        <li className ="nav-item">
                                            <NavLink to={'/urm/roles'} className ="nav-link"> Roles </NavLink>
                                        </li>
                                        <li className ="nav-item">
                                            <NavLink to={'/urm/modules'} className ="nav-link"> Modules </NavLink>
                                        </li>
                                        <li className ="nav-item">
                                            <NavLink to={'/urm/users'} className ="nav-link"> Users </NavLink>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </li>
                            ):(<></>)

                                                        
                        } */}


                </ul>
                {/* <!-- Sidebar --> */}
            </div>
        </div>
    )
}

export default Sidebar